// Optimizers behind the "Optimize" buttons of the tool, one entry per category ordering-dependent metric.
// Defaults until the selection of todo/03 S7 is decided; change them here only.
export const TOOL_DEFAULTS = {
    // First-attribute modes of the selector: the attribute currently first stays first (categories free),
    // its category order is fixed as well, the attribute with the highest entropy becomes the first (automatic),
    // or all attribute orders are searched.
    modes: ['firstAttribute', 'firstOrder', 'entropyFirst', 'unconstrained'],
    defaultMode: 'firstAttribute',
    metrics: {
        crossings: { optimizer: 'crossingsBnb', options: {} },
        // Surrogate plus block polish (decision 2026-10-02: milliseconds; the exact overlapBnb takes 20 to 32 s on
        // three-attribute data). optimize() still accepts optimizer: 'overlapBnb' in a request.
        overlap: { optimizer: 'overlapSurrogate', options: {} },
        slope: { optimizer: 'multiStart', options: { starts: 20, seed: 1, neighborhood: 'insert', strategy: 'first' } },
        orthogonality: { optimizer: 'multiStart', options: { starts: 20, seed: 1, neighborhood: 'insert', strategy: 'first' } },
        crossingAngle: { optimizer: 'multiStart', options: { starts: 20, seed: 1, neighborhood: 'insert', strategy: 'first' } },
    },
};
